/**
 * Statistik (Trainer/Admin) — Nutzung & Fortschritt. Serverseitig rollen-gegated
 * (401/403 → Logout). Das Antwortschema ist backendseitig flexibel; wir zeigen
 * die gelieferten Kennzahlen kompakt an.
 */
import { useEffect, useState } from "preact/hooks";
import { endpoints } from "../api/endpoints";

function flatten(obj: Record<string, unknown>): Array<[string, string]> {
  const out: Array<[string, string]> = [];
  for (const [k, v] of Object.entries(obj || {})) {
    if (v == null) continue;
    if (typeof v === "object") out.push([k, `${Array.isArray(v) ? v.length + " Einträge" : "…"}`]);
    else out.push([k, String(v)]);
  }
  return out;
}

function StatsBlock({ title, data }: { title: string; data: Record<string, unknown> }) {
  const rows = flatten(data);
  if (!rows.length) return null;
  return (
    <div class="glass card-pad">
      <strong class="quota-title">{title}</strong>
      <div class="stack" style="gap:8px">
        {rows.map(([k, v]) => (
          <div key={k} class="quota-head">
            <span class="quota-label">{k}</span>
            <span class="quota-values">{v}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function Stats() {
  const [usage, setUsage] = useState<Record<string, unknown> | null>(null);
  const [progress, setProgress] = useState<Record<string, unknown> | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    endpoints.statsUsage().then(setUsage).catch(() => setError(true));
    endpoints.statsProgress().then(setProgress).catch(() => {});
  }, []);

  return (
    <div class="stack">
      <div>
        <h2 class="section-title">Statistik</h2>
        <p class="section-sub">Nutzung &amp; Fortschritt — nur für Trainer/Admin.</p>
      </div>
      {error && !usage ? (
        <div class="glass card-pad">
          <p class="text-muted" style="margin:0">
            Statistik konnte nicht geladen werden (oder keine Berechtigung).
          </p>
        </div>
      ) : !usage ? (
        <div class="glass card-pad">
          <p class="text-muted" style="margin:0">Wird geladen …</p>
        </div>
      ) : (
        <>
          <StatsBlock title="Nutzung" data={usage} />
          {progress ? <StatsBlock title="Fortschritt" data={progress} /> : null}
        </>
      )}
    </div>
  );
}
